define('modules/image_picker/image_picker_image_item_view',[
  'backbone',
  'jquery',
  '_',
  'session',


  'modules/animation/transition-end',

  'modules/util/collection/collection_view',

  'text!./image_picker_image_item_template.html',
  'text!./image_picker_header_template.html'
], function (Backbone, $, _, session,


            transitionEnd,
            CollectionView,
            item_template,
            header_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      this.model.set(this.extraParams, {silent: true});

      this.render();
    },

    subViews: [],
    tagName: 'li',

    item_template: _.template(item_template),

    events: {
      'click .js-preview-image': 'previewImage',
      'click .js-pick-image': 'pickImage'
    },

    render: function () {

      this.$el.html(this.item_template(this.model.toJSON()));
      return this;
    },

    previewImage: function (e) {
      e.preventDefault();


    },

    closePreview: function () {
      session.unset('current_preview');
      this.$el.removeClass('is-active');
      this.$('.js-preview-container').removeClass('is-open');
    },


    pickImage: function (e) {
      this.extraParams.onSelect(this.model);
    },



    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  },

  {
    header: function (collection) {
      return _.template(header_template)(collection.params);
    },

    viewTypes: [CollectionView.GRID]

  });
  return View;
});

